<template>
<form class="was-validated">
  <div class="custom-file">
    <input type="file" class="custom-file-input" ref="fileUploader" id="validatedCustomFile" required @change="filesAdded">
    <label class="custom-file-label" for="validatedCustomFile">Choose file...</label>
    <div class="invalid-feedback">Please choose file</div>
  </div>
  <div v-if="uploading" class="progress">
    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
  </div>
  <div v-if="fileUrl !== ''">
      <a :href="fileUrl" class="badge badge-dark">Download Attachment</a>
      <button @click="removeFile" type="button" class="btn btn-outline-dark btn-sm rounded-circle"><i class="far fa-trash-alt"></i></button>
  </div>
</form>
</template>

<script>
import { baseApiUrl } from '../config'
import api from '../services/api'

export default {
    props: ['fileUrl', 'fieldName'],
    data() {
        return {
            fileData: new FormData(),
            uploadStatus: false,
            previewImage: [],
            uploading: false
        }
    },
    methods: {
        async uploadAll() {
            if(this.uploadStatus) {
                this.uploading = true
                const uploadApi = api('upload')
                const assetsName = await uploadApi.upload(this.fileData)
                console.log(assetsName)
                const newFile = {
                    [this.fieldName]: assetsName
                }
                this.$emit('finishUpload', newFile)
                this.uploading = false
            }
        },
        filesAdded(file) {
            this.readyUpload(this.$refs.fileUploader.files)
        },
        // track for changed file and update the form data
        readyUpload(file) {
            // handle file changes
            const fileList = file
            
            if (!fileList.length) return
            
            // this.createData(fileList)

            // append the files to FormData
            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                this.fileData.append('upload', fileList[x], fileList[x].name)
            })
            
            this.uploadStatus = true
            this.uploadAll()
        },
        async removeFile() {
            const newFile = {
                    [this.fieldName]: ''
                }
            this.$emit('finishUpload', newFile)
        }
        // for preview
        // createData(file) {
        //     for(let index=0; index<file.length; index++) {
        //         var image = new Image()
        //         var reader = new FileReader()

        //         reader.onload = (e) => {
        //             this.previewImage.push(e.target.result)
        //         };
        //         reader.readAsDataURL(file[index])
        //     }
        // },
    }
}
</script>